import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import Cesium3DTile from "cesium/Source/Scene/Cesium3DTile";
import { Constants } from "../../Constants";

const Cesium = (<any>window).Cesium;

export class BucketActionController {

    debug:boolean = Constants.debug_off;
    debugPrimary:string = Constants._orange;
    debugSecondary:string = Constants._white;

    id:string = null;

    // actions on the bucket as a whole
    bucketActions:any = [];

    // generic actions per item in the bucket
    itemActions:any = [];

    // show / hide bucket
    show:boolean = true;
    showCallback:any = null;

    // open / closed bucket
    open:boolean = false;

    // items (items in the bucket)
    items:any = [];
    selectedItem:any = null;
    selectedEdit:boolean = false;

    // injected item to save / load on (Transform, Annotation, TransformGroup, any Vasat object, really)
    object:any = null;

    // structure is the property name we're saving / loading with
    structure:string = null;

    // itemSelector is an optional function we run when an item is selected
    itemSelector:any = null;

    // show options
    showNavigation:boolean = false;

    interval:any = null;

    constructor ( config:any = {} ) {
        if ( this.debug ) { console.log ( "%c bucket-action-controller %c CONSTRUCTOR()", this.debugPrimary, this.debugSecondary, this, config ); }
        this.config ( config );
        if ( !this.interval ) {
            this.interval = setInterval ( () => {
                this.refresh();
            }, 1000 );
        }
    }

    destroy() {
        if ( this.debug ) { console.log ( "%c bucket-action-controller %c destroy()", this.debugPrimary, this.debugSecondary, this ); }
        this.unloadAllItems();
        clearInterval(this.interval);
        this.interval = null;
    }

    unloadAllItems() {
        if ( this.debug ) { console.log ( "%c bucket-action-controller %c unloadAllItems()", this.debugPrimary, this.debugSecondary, this ); }
        let data = this.items;
        if ( data && data.length ) {
            data.forEach( item => {
                this.itemUnload(item);
            });
        }
    }

    refresh() {
        if ( !this.showCallback ) {
            return;
        }
        const sc = this.showCallback;
        const gv = sc ? sc['getValue'] : false;
        const v = gv ? sc.getValue() : false;
        this.show = v ? true : false;
        // console.log('###@@@', this.structure, [sc, gv, v] );
    }
    
    config ( config:any = {} ) {
        // console.log ( 'bucket-action-controller :: config()', config );
        if ( config.object ) {
            this.object = config.object;
            this.injectedObject();
        }
        if ( config.structure ) {
            this.id = config.structure;
            this.structure = config.structure;
        }
        if ( config.name ) {
            this.id = config.name;
        }
        if ( config.id ) {
            this.id = config.id;
        }
        if ( config.hasOwnProperty('showNavigation') ) {
            this.showNavigation = config.showNavigation;
        }
        if ( config.hasOwnProperty('show') ) {
            this.show = config.show;
        }
        if ( config.hasOwnProperty('showCallback') ) {
            this.showCallback = config.showCallback;
        }
        if ( config.itemSelect ) {
            this.itemSelector = config.itemSelect;
        }
        if ( config.bucketActions && config.bucketActions.length ) {
            config.bucketActions.forEach ( action => {
                if ( action.name && this[action.name] ) {
                    this.bucketActions.push({ name: action.name, location: 'this', icon: action.icon ? action.icon : 'cog', getData: action.getData ? action.getData : null, tooltip: action.tooltip ? action.tooltip : '' });
                } else if ( action.name && !this[action.name] ) {
                    if ( action.func ) {
                        this[action.name] = action.func;
                        this.bucketActions.push({ name: action.name, location: 'func', icon: action.icon ? action.icon : 'cog', getData: action.getData ? action.getData : null, tooltip: action.tooltip ? action.tooltip : '' });
                    } else {
                        this.bucketActions.push({ name: action.name, location: 'null', icon: action.icon ? action.icon : 'times', getData: action.getData ? action.getData : null, tooltip: action.tooltip ? action.tooltip : '' });
                    }
                }
            });
        }
        if ( config.itemActions && config.itemActions.length ) {
            config.itemActions.forEach ( action => {
                if ( action.name && this[action.name] ) {
                    this.itemActions.push({ name: action.name, location: 'this', icon: action.icon ? action.icon : 'cog', getData: action.getData ? action.getData : null, tooltip: action.tooltip ? action.tooltip : '' });
                } else if ( action.name && !this[action.name] ) {
                    if ( action.func ) {
                        this[action.name] = action.func;
                        this.itemActions.push({ name: action.name, location: 'func', icon: action.icon ? action.icon : 'cog', getData: action.getData ? action.getData : null, tooltip: action.tooltip ? action.tooltip : '' });
                    } else {
                        this.itemActions.push({ name: action.name, location: 'null', icon: action.icon ? action.icon : 'times', getData: action.getData ? action.getData : null, tooltip: action.tooltip ? action.tooltip : '' });
                    }
                }
            });
        }
    }

    // event for when an object is injected; look for and ingest serialised data
    injectedObject() {
        // console.log ( 'bucket-action-controller :: injectedObject()', this.object, this.structure );
        if ( this.debug ) { console.log ( "%c bucket-action-controller %c injectedObject()", this.debugPrimary, this.debugSecondary, this.object ); }
        this.items = [];
        if ( this.object && this.structure ) {
            let data = this.object[this.structure];
            if ( data && data.length ) {
                this.items = data;
                if ( data && data.length ) {
                    data.forEach( item => {
                        this.itemLoad(item);
                    });
                }
            } 
        }
    }

    saveToObject() {
        // console.log ( 'bucket-action-controller :: saveToObject()', this.object );
        if ( this.selectedItem ) {
            let pos = this.items.map(function(e) { return e.id; }).indexOf(this.selectedItem.id);
            if ( pos !== -1 ) {
                this.items[pos] = this.selectedItem;
            }
        }
        if ( this.object && this.structure ) {
            this.object[this.structure] = this.items;
            if ( this.object.saveObservable ) {
                this.object.saveObservable().subscribe();
            } 
        }
    }

    bucketAction ( action:any ) {
        let data = null;
        if ( action.getData ) {
            data = action.getData();
        }
        // console.log ( 'bucket-action-controller :: bucketAction()', this, action, data );
        if ( action.location == 'this' || action.location == 'func' ) {
            // console.log ( 'bucket-action-controller :: bucketAction() ACTION' );
            this[action.name](data);
        }
    }

    itemLoad(item:any) {
        if ( this.debug ) { console.log ( "%c bucket-action-controller %c itemLoad()", this.debugPrimary, this.debugSecondary, item ); }
        this.__itemLoad(item);
    }
    __itemLoad(item:any = null) {}
    

    itemUnload(item:any) {
        if ( this.debug ) { console.log ( "%c bucket-action-controller %c itemUnload()", this.debugPrimary, this.debugSecondary, item ); }
        this.__itemUnload(item);
    }
    __itemUnload(item:any = null) {}

    itemAction ( item:any, action:any ) {
        // console.log ( 'bucket-action-controller :: itemAction()', this, item, action );
        if ( action.location == 'this' || action.location == 'func' ) {
            if ( this.debug ) { console.log ( 'bucket-action-controller :: itemAction() ACTION' ); }
            this[action.name](item);
        }
    }

    itemUnselect ( item:any = null ) {
        if ( this.debug ) { console.log ( "%c bucket-action-controller %c itemUnselect()", this.debugPrimary, this.debugSecondary, item ); }
        this.selectedItem = null;
        // this.buckets.isInactive(this.controller);
    }

    itemSelect ( item:any ) {
        // console.log ( 'bucket-action-controller :: itemSelect()', this, item );
        if ( this.debug ) { console.log ( "%c bucket-action-controller %c itemSelect()", this.debugPrimary, this.debugSecondary, item ); }
        this.selectedItem = item;
        if ( this.itemSelector ) {
            // console.log ( 'bucket-action-controller :: itemSelect() SELECT' );
            this.itemSelector( item );
        }
    }

    itemDropped ( event: CdkDragDrop<any[]> ) {
        moveItemInArray(this.items, event.previousIndex, event.currentIndex);
        this.saveToObject();
    }

    add ( data:any = null, label:string = null, desc:string = null ) {
        let c = {
            id: this.uuidv4(),
            label: label ? label : new Date().toISOString(),
            desc: desc,
            data: data
        };
        this.items.push(c);
        this.itemLoad(c);
        this.saveToObject();
        if ( !this.open ) {
            this.open = true;
        }
        // console.log ( 'bucket-action-controller :: add()', this.items );
    }

    delete ( item:any = null ) {
        if ( !item ) {
            return null;
        }
        let id = item.id;
        if ( this.selectedItem && this.selectedItem.id == id ) {
            this.selectedItem = false;
        }
        let find = this.items.find ( i => i.id == id );
        if ( find ) {
            this.itemUnload(item);
            this.items = this.items.filter ( i => i.id != id );
        }
        this.saveToObject();
        // console.log ( 'bucket-action-controller :: delete()', id, this.items );
    }

    hasPrevious ( c:any, showPos:boolean = false ) {
        let pos = this.items.map(function(e) { return e.id; }).indexOf(c.id);
        if ( showPos ) { return '' + pos + ' > 0'; }
        if ( pos > 0 ) {
            return true;
        }
        return false;
    }
    
    previous ( c:any ) {
        let pos = this.items.map(function(e) { return e.id; }).indexOf(c.id);
        if ( pos > 0 ) {
            this.itemSelect(this.items[pos-1]);
        }
    }
    
    hasNext ( c:any, showPos:boolean = false ) {
        let pos = this.items.map(function(e) { return e.id; }).indexOf(c.id);
        if ( showPos ) { return '' + pos + ' < ' + ( this.items - 1 ); }
        if ( pos < this.items.length - 1 ) {
            return true;
        }
        return false;
    }
    
    next ( c:any ) {
        let pos = this.items.map(function(e) { return e.id; }).indexOf(c.id);
        if ( pos < this.items.length - 1 ) {
            this.itemSelect(this.items[pos+1]);
        }
    }


    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}